var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "130px",
    viewBox: "0 0 140 143",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Docs Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCC2-Empty-State",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-building-1",
    transform: "translate(-117.000000, -35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Docs-Icon",
    transform: "translate(121.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.7105533,77.51914 L80.0758867,75.9725733 L79.2265533,75.4738067 L78.84002,76.3799067 L78.5288867,77.1092067 C77.29302,80.01124 74.8355867,81.8139067 72.11642,81.8139067 C69.3963867,81.8139067 66.9393867,80.01124 65.7039533,77.10964 L65.39282,76.38034 L65.00672,75.4733733 L64.1569533,75.9725733 L61.5222867,77.51914 L60.86492,77.90524 L61.1634867,78.6063733 L61.4741867,79.3356733 C63.4887533,84.0663733 67.56642,87.0056733 72.11642,87.0056733 C76.6659867,87.0056733 80.7436533,84.0663733 82.75822,79.33524 L83.0693533,78.6063733 L83.3687867,77.90524 L82.7105533,77.51914 Z M53.3881867,75.9725733 L52.53842,75.4738067 L52.1518867,76.3799067 L51.8411867,77.1092067 C50.6048867,80.01124 48.1478867,81.8139067 45.4282867,81.8139067 C42.7086867,81.8139067 40.2516867,80.01124 39.01582,77.10964 L38.7046867,76.38034 L38.31902,75.4733733 L37.46882,75.9725733 L34.8341533,77.51914 L34.1767867,77.90524 L34.4753533,78.6063733 L34.7860533,79.3356733 C36.80062,84.0663733 40.8782867,87.0056733 45.4282867,87.0056733 C49.9778533,87.0056733 54.05552,84.0663733 56.0700867,79.33524 L56.38122,78.6063733 L56.6806533,77.90524 L56.0228533,77.51914 L53.3881867,75.9725733 Z",
    id: "Fill-1",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2060333,102.088143 C56.9267,102.088143 55.0798333,103.935877 55.0798333,106.214343 C55.0798333,108.493243 56.9267,110.340543 59.2060333,110.340543 C61.4845,110.340543 63.3318,108.493243 63.3318,106.214343 C63.3318,103.935877 61.4845,102.088143 59.2060333,102.088143",
    id: "Fill-3",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#9B9B9B",
    points: "135.208117 43.2399933 135.208117 46.1558933 123.54495 46.1558933 123.54495 43.8717933 130.202683 35.99856 123.71525 35.99856 123.71525 33.08266 134.990583 33.08266 134.990583 35.36676 128.332417 43.2399933"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#9B9B9B",
    points: "129.374193 17.1898133 129.37636 22.12418 109.638027 22.1324133 109.636293 18.26708 120.89906 4.93818 109.91926 4.94251333 109.917093 0.00771333333 128.99936 0.000346666667 129.001093 3.86524667 117.737893 17.19458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.147371,43.4422237 L102.858642,129.861413 C102.935181,133.726649 99.8638361,136.922089 95.9986006,136.998628 C95.9524106,136.999543 95.9062128,137 95.8600139,137 L22,137 C18.1340068,137 15,133.865993 15,130 L15,43 L15,43",
    id: "Rectangle",
    stroke: "#E6E6E6",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 56,
    x2: 59.5,
    y2: 2.5,
    id: "Line",
    stroke: "#E6E6E6",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 56,
    x2: 113.5,
    y2: 2.5,
    id: "Line",
    stroke: "#E6E6E6",
    strokeWidth: 8,
    strokeLinecap: "round",
    transform: "translate(86.500000, 29.000000) scale(-1, 1) translate(-86.500000, -29.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationEmpty);
export default __webpack_public_path__ + "static/media/location_empty.34cd6634f65251b5dce5b9bc700ac1c8.svg";
export { ForwardRef as ReactComponent };